import { render, staticRenderFns } from "./SlidesPer.vue?vue&type=template&id=8276e3f8&scoped=true"
import script from "./SlidesPer.vue?vue&type=script&lang=js"
export * from "./SlidesPer.vue?vue&type=script&lang=js"
import style0 from "./SlidesPer.vue?vue&type=style&index=0&id=8276e3f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8276e3f8",
  null
  
)

export default component.exports